import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { useContext } from "react";
import { loginRequest, loginSilentRequest } from "../services/auth/auth-config";
import { EnvContext } from "../services/env";

export default function useAuthToken(): [
  () => Promise<string | undefined>
] {
  const envConfig = useContext(EnvContext);

  const { instance, inProgress } = useMsal();

  const getAuthentication = async () => {
    const activeAccount = instance.getActiveAccount();
    const accounts = instance.getAllAccounts();

    if (inProgress !== InteractionStatus.None) {
      return undefined;
    }

    if (!activeAccount && accounts.length === 0 && inProgress === InteractionStatus.None) {
      console.log("No ative account, redirect now")
      instance.acquireTokenRedirect(loginRequest(envConfig))
      return undefined;
    }

    return instance.acquireTokenSilent({
      ...loginSilentRequest(envConfig),
      account: accounts[0],
    }).catch((error) => {
      console.log("Failed to acquire token silently, redirect now", error)
      instance.acquireTokenRedirect(loginRequest(envConfig));
      return undefined;
    });
  };

  const getAccessToken = () => getAuthentication().then(response => response?.accessToken);

  return [getAccessToken];
}
